"use client";

import { useSearchParams } from "next/navigation";
import type { ReactNode } from "react";
import { Suspense } from "react";
import { BibliographyStudio } from "@/components/bibliography-studio/studio";
import type { StudioChromeStrings } from "@/components/bibliography-studio/studio-chrome";

interface StudioEntryProps {
  locale: string;
  defaultOutputLocale?: string;
  title: string;
  chrome: StudioChromeStrings;
  share?: ReactNode;
}

function StudioWithParams(props: StudioEntryProps) {
  const searchParams = useSearchParams();
  // `?source=` is the same deep link the homepage and bookmarklet use; here it opens
  // the add panel with the source already cited so "cite this and file it" is one hop.
  const source = searchParams.get("source") ?? undefined;
  return <BibliographyStudio {...props} source={source} />;
}

/** `useSearchParams` needs a Suspense boundary on a statically rendered page. */
export function StudioEntry(props: StudioEntryProps) {
  return (
    <Suspense fallback={<BibliographyStudio {...props} />}>
      <StudioWithParams {...props} />
    </Suspense>
  );
}
